import { useMutation } from '@apollo/client';
import { ValidateUserMergeRequestDocument } from 'src/graphql/generated/graphql';

export const useUserMergeRequestValidate = () => {
  return useMutation(ValidateUserMergeRequestDocument);
};
